/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Data_TitleInputs */

const da_terms_data_title = /** @type {(inputs: Terms_Data_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elevdata`)
};

/** @type {(inputs: Terms_Data_TitleInputs) => LocalizedString} */
const en_terms_data_title = da_terms_data_title;

/**

* @param {Terms_Data_TitleInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const terms_data_title = /** @type {((inputs?: Terms_Data_TitleInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Data_TitleInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_data_title(inputs)
	return /** @type {LocalizedString} */ ("Elevdata")
});